import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AssignmentEvaluationService {
  constructor(private httpService: HttpService) {}

  createEvaluation(body) {
    try {
      return firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Evaluation}`, body));
    } catch (error) {
      throw error;
    }
  }

  async getEvaluation(assignmentId) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Evaluation}`, {
          params: assignmentId,
        })
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getEvaluationByQuestionIdAndCorrectNess(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.assignment_evaluation_by_question_id_and_correctness}`,
          queryParams
        )
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getEvaluationById(id) {
    try {
      return firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.AssignmentevaluationById}/${id}`));
    } catch (error) {
      throw error;
    }
  }

  getStudentEvaluation(userId, assignmentId) {
    try {
      return firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Evaluation}/${userId}/${assignmentId}`));
    } catch (error) {
      throw error;
    }
  }

  async getEvaluationByUserId(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.assignmentEvaluationByUserId}`, queryParams)
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getAssignmentsByUserId(userId, queryParams) {
    try {
      const params = new HttpParams();
      params.set('assignmentsId', queryParams);
      return firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.getAssignmentsByUserId}/${userId}/`, {
          assignmentsId: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async updateEvaluation(id, body) {
    try {
      const response = await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Evaluation}/${id}`, body));
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  getAnswer(data) {
    try {
      return firstValueFrom(this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.getAnswer}`, data));
    } catch (error) {
      throw error;
    }
  }

  async updateSavedAnswerOfStudentAssignment(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.update_saved_answer_of_student_assignment}`, queryParams)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getAssignmentEvaluation(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.get_assignment_evaluation}`, {
          params: body,
        })
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}
